import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import InsertHeadContent from './InsertHeadContent';

export default function CasinoInsertHead() {
  return (
    <CasinoContainer title={'Inserting HTML code into the <title> and <head>'}>
      <InsertHeadContent />
    </CasinoContainer>
  );
}
